import { Box, Button, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { TABS_BLUE } from 'utilities/colors';
import { EditSampleButton } from 'components/SampleEditor/components/EditSampleButton';
import { useSlideMetadataWithScienceInfoStyles } from 'components/PathologyMap/Modals/FullSlideInfoModal/SlideInfoSection/styles';
import { setExpanded } from 'store/slices/slidesListSlice/slidesListSlice';
import { CollapseIcon } from 'images/icons/CollapseIcon';
import { ExpandIcon } from 'images/icons/ExpandIcon';
import React from 'react';
import { useDispatch } from 'react-redux';

const TabLabel = ({ classes, name, itemsCount }) => (
  <Tooltip title={name}>
    <Box display="flex">
      <Typography className={classes.tabLabel}>{name}</Typography>
      <Typography component="span" className={classes.itemsCount}>
        {itemsCount || 0}
      </Typography>
    </Box>
  </Tooltip>
);

export const SlideMetadataHeader = ({
  slide,
  currentTab,
  handleTabsChange,
  standardMetadataItemsCount,
  scienceInfoItemsCount,
  isExpanded,
  isTop,
  isOrderSlide,
  getMetaData,
}) => {
  const { classes } = useSlideMetadataWithScienceInfoStyles();
  const dispatch = useDispatch();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Tabs
        value={currentTab}
        onChange={handleTabsChange}
        TabIndicatorProps={{
          style: {
            backgroundColor: TABS_BLUE,
          },
        }}
        className={classes.tabs}
      >
        <Tab
          label={
            <TabLabel
              classes={classes}
              name="Standard Metadata"
              itemsCount={standardMetadataItemsCount}
            />
          }
          className={classes.tab}
          id="standard-metadata"
        />
        <Tab
          label={
            <TabLabel
              classes={classes}
              name="Science Info"
              itemsCount={scienceInfoItemsCount}
            />
          }
          className={classes.tab}
          id="science-info"
        />
        <EditSampleButton sampleId={slide?.sample?.id} />
      </Tabs>
      {isOrderSlide && (
        <Button
          onClick={() => {
            dispatch(setExpanded({ isExpanded: !isExpanded, isTop }));
            getMetaData();
          }}
          variant="outlined"
          className={classes.expandButton}
        >
          {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
        </Button>
      )}
    </Box>
  );
};
